<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle r="15" transform="matrix(1 0 0 -1 15 15)" fill="#FFEBE8" />
    <path d="M8.58216 21.4187L8.58216 19.1216L17.6808 19.1135L7.7676 9.20028L9.39672 7.57116L19.3099 17.4843L19.3018 8.38572L21.6151 8.38572L21.6151 21.4187L8.58216 21.4187Z" fill="#EC3B1C" />
  </svg>
</template>
